<div class="kb-article-form-container">
  <ngx-spinner bdColor="rgba(0,0,0,0.3)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="color: white">Saving...</p>
  </ngx-spinner>

  <!-- Back button -->
  <div class="mb-3">
    <button nbButton ghost size="small" (click)="goBack()">
      <nb-icon icon="arrow-back-outline" pack="eva"></nb-icon> Back to Support
    </button>
  </div>

  <nb-card>
    <nb-card-header>
      <h4 class="mb-0">{{ isEditMode ? 'Edit Article' : 'New Article' }}</h4>
    </nb-card-header>

    <nb-card-body>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">

        <!-- Title -->
        <div class="form-group mb-3">
          <label class="form-label">Title <span class="text-danger">*</span></label>
          <input nbInput fullWidth formControlName="title" placeholder="Article title" />
          <div class="text-danger small mt-1"
               *ngIf="form.get('title')?.invalid && form.get('title')?.touched">
            Title is required.
          </div>
        </div>

        <!-- Category -->
        <div class="form-group mb-3">
          <label class="form-label">Category <span class="text-danger">*</span></label>
          <nb-select formControlName="category" fullWidth placeholder="Select category">
            <nb-option *ngFor="let cat of categories" [value]="cat.slug">{{ cat.name }}</nb-option>
          </nb-select>
          <div class="text-danger small mt-1"
               *ngIf="form.get('category')?.invalid && form.get('category')?.touched">
            Category is required.
          </div>
        </div>

        <!-- Tags -->
        <div class="form-group mb-3">
          <label class="form-label">Tags</label>
          <input nbInput fullWidth formControlName="tags" placeholder="Comma-separated: e.g. pos, payments, setup" />
        </div>

        <!-- Audience -->
        <div class="form-group mb-3">
          <label class="form-label">Audience</label>
          <div class="d-flex flex-wrap gap-3">
            <div *ngFor="let r of AUDIENCE_ROLES" class="form-check">
              <input class="form-check-input" type="checkbox"
                     [id]="'audience_' + r.value"
                     [checked]="isAudienceSelected(r.value)"
                     (change)="toggleAudience(r.value)" />
              <label class="form-check-label" [for]="'audience_' + r.value">{{ r.label }}</label>
            </div>
          </div>
          <small class="text-muted mt-1 d-block">Leave all unchecked to make the article public (visible to all roles).</small>
        </div>

        <!-- Status toggle -->
        <div class="form-group mb-3 d-flex align-items-center gap-2">
          <label class="form-label mb-0 me-2">Status:</label>
          <nb-toggle formControlName="status" [checked]="form.get('status')?.value === 1"
                     (checkedChange)="form.get('status')?.setValue($event ? 1 : 0)">
            {{ form.get('status')?.value === 1 ? 'Published' : 'Draft' }}
          </nb-toggle>
        </div>

        <!-- Content -->
        <div class="form-group mb-4" (paste)="onEditorPaste($event)">
          <label class="form-label">Content <span class="text-danger">*</span></label>
          <angular-editor formControlName="content" [config]="editorConfig"></angular-editor>
          <div class="text-danger small mt-1"
               *ngIf="form.get('content')?.invalid && form.get('content')?.touched">
            Content is required.
          </div>
        </div>

        <!-- Submit -->
        <div class="form-actions">
          <button type="submit" nbButton status="primary" [disabled]="submitting">
            {{ isEditMode ? 'Update Article' : 'Create Article' }}
          </button>
          <button type="button" nbButton ghost class="ms-2" (click)="goBack()">
            Cancel
          </button>
        </div>

      </form>
    </nb-card-body>
  </nb-card>
</div>
